interface GroupUserPickerUser {
	accountId: string;
	accountType: 'app' | 'atlassian' | 'customer';
	displayName: string;
	avatarUrl: string;
}

interface GroupUserPickerGroup {
	groupId: string;
	name: string;
}

export interface GroupUserPickerResponse {
	users: {
		total: number;
		users: GroupUserPickerUser[];
	};
	groups: {
		total: number;
		groups: GroupUserPickerGroup[];
	};
}

export interface CustomerOrganization {
	externalId: string;
	name: string;
}

export const USER_ARI_PREFIX = 'ari:cloud:identity::user';
export const GROUP_ARI_PREFIX = 'ari:cloud:identity::group';
export const CUSTOMER_ORGANIZATION_ARI_PREFIX = 'ari:cloud:identity::customer-organization';
